import { useEffect, useState } from "react";
import { Typography, Paper, Box } from "@mui/material";
import { useApp } from "../../context/AppContext";
import { useLanguage } from "../../context/LanguageContext";

import nothingImg from "../../assets/img/nothing.svg"
import TransactionCard from "../Transaction/TransactionCard";

export default function Transactions() {
  const { transactions, fetchTransactions, loading } = useApp();
  const { t } = useLanguage();

  useEffect(() => {
    // Делаем запрос при каждом переходе на страницу
    fetchTransactions();
  }, []); // Запускаем только один раз при монтировании

  return (
    <Box sx={{ padding: { xs: 2, sm: 3 } }}>
      {/* Список транзакций */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 2
      }}>
        {loading ? (
          <Box sx={{ 
            textAlign: 'center', 
            padding: 4,
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            borderRadius: 2,
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: { xs: '1rem', sm: '1.125rem' }
              }}
            >
              {t('loadingTransactions')}
            </Typography>
          </Box>
        ) : transactions && transactions.length > 0 ? (
          transactions.map(tx => (
            <TransactionCard key={tx.id} transaction={tx} />
          ))
        ) : (
          <Paper 
            elevation={0} 
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              borderRadius: 2,
              border: '1px solid rgba(255, 255, 255, 0.1)',
              padding: { xs: 3, sm: 4 },
              textAlign: 'center'
            }}
          >
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              gap: 2 
            }}>
              <Box sx={{ 
                width: { xs: 120, sm: 150 }, 
                height: { xs: 120, sm: 150 },
                opacity: 0.5
              }}>
                <img 
                  src={nothingImg} 
                  alt="No transactions" 
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </Box>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: { xs: '1.125rem', sm: '1.25rem' }
                }}
              >
                {t('nothingHere')}
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }}
              >
                {t('noTransactions')}
              </Typography>
            </Box>
          </Paper>
        )}
      </Box>
    </Box>
  );
}